import * as React from 'react'
import { RadioGroup as RadioGroupPrimitive, Radio as RadioPrimitive } from '@base-ui/react'

import { cn } from '@/components/new/lib/utils'

const RadioGroup = React.forwardRef<HTMLDivElement, React.ComponentProps<typeof RadioGroupPrimitive>>(
    ({ className, ...props }, ref) => (
        <RadioGroupPrimitive
            ref={ref}
            data-slot="radio-group"
            className={cn('grid w-full gap-3', className)}
            {...props}
        />
    )
)

RadioGroup.displayName = 'RadioGroup'

const RadioGroupItem = React.forwardRef<HTMLSpanElement, React.ComponentProps<typeof RadioPrimitive.Root>>(
    ({ className, ...props }, ref) => (
        <RadioPrimitive.Root
            ref={ref}
            data-slot="radio-group-item"
            className={cn(
                'group/radio-group-item border-input focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 aria-invalid:aria-checked:border-primary dark:bg-input/30 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 data-checked:border-primary data-checked:bg-primary data-checked:text-primary-foreground dark:data-checked:bg-primary peer relative flex aspect-square size-4 shrink-0 rounded-full border outline-none after:absolute after:-inset-x-3 after:-inset-y-2 disabled:cursor-not-allowed disabled:opacity-50',
                className
            )}
            {...props}
        >
            <RadioPrimitive.Indicator
                render={
                    <span className="bg-primary-foreground absolute left-1/2 top-1/2 size-2 -translate-x-1/2 -translate-y-1/2 rounded-full" />
                }
            />
        </RadioPrimitive.Root>
    )
)

RadioGroupItem.displayName = 'RadioGroupItem'

export { RadioGroup, RadioGroupItem }
